import { render } from "./ViewProfile.vue?vue&type=template&id=f7b4b9d6"
import script from "./ViewProfile.vue?vue&type=script&lang=js"
export * from "./ViewProfile.vue?vue&type=script&lang=js"
script.render = render

export default script